export default {
  created: 1,
  sent: 2,
  not_paid: 3,
  partly_paid: 4,
  paid: 5,
  deleted: 6,
  reminder_required: 100,
};
